<template>
    <div class="innerBox" style="border-radius: 16px;">

        <div class="row">
            <div class="col-md-6">
                <span class="section--title">DO Pending</span>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-6 col-md-3 offset-md-6">                        
                        <multiselect 
                            :options="options.color.map(x => x.color)"
                            :custom-label="opt => options.color.find(x => x.color == opt).name"
                            placeholder="All Color"
                            v-model="filter.color"
                        /></multiselect>
                    </div>
                    <div class="col-6 col-md-3">
                        <button
                            class="btn btn-dh-download"
                            @click="exportCsv(rawData, 'DO Pending')"
                        >Download CSV&nbsp;&nbsp;<i class="fas fa-download"></i></button>
                    </div>
                </div>
            </div>
        </div>

        <do-pending-table
            v-if="data"
            :data="data"
        ></do-pending-table>
        <div style="min-height: 300px; display: flex; align-items: center; justify-content: center;" v-else>
            <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
        </div>

    </div>
</template>

<script>
    import qs from 'qs'
    import multiselect from 'vue-multiselect'

    import doPendingTable from './children/doPendingTable'

    export default {
        data () {
            return {
                options : {
                    color : this.$store.getters.getColor
                },
                filter : {
                    color : null,
                },

                rawData : null,
                data : null,
            }
        },
        components : {
            multiselect,

            doPendingTable,
        },
        mounted () {
            this.fetchData();
        },
        watch : {
            filter : {
                deep : true,
                handler : 'fetchData'
            }
        },
        methods : {
            fetchData () {
                //Reset loading...
                this.data = null;

                this.$http.get(`/api/highlight-dealer/do-pending${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
                .then(async (resp)=>{
                    this.rawData = resp.data.data;
                    this.data = await this.groupByInvoice(resp.data.data);
                })
                .catch((err)=>{console.log(err)})
            },
            groupByInvoice (data) {
                let compiledData = {};

                for (var i in data) {

                    //Generate invoice object if not exist yet
                    if (compiledData[data[i].no_invoice] == null) {
                        compiledData[data[i].no_invoice] = {
                            invoice : data[i].no_invoice,
                            sl_no : data[i].no_sl_dealer,
                            content : []
                        }
                    }

                    //Add data to invoice object
                    compiledData[data[i].no_invoice].content.push({
                        type : data[i].kd_type,
                        color : data[i].kd_warna,
                        doPending : parseInt(data[i].do_pending)
                    })

                }

                return Object.values(compiledData);
            },
        }
    }
</script>

<style scoped>
    
</style>